<template>
  <modalForm :title="$t('canned.editTitle')" :submit-label="$t('actions.save')" v-on:submit-event="onSubmit" v-on:cancel-event="cancel">
    <div v-if="error" class="text-red-600 text-sm font-bold mt-1 mb-1">{{ error }}</div>
    <div class="mt-4">
      <p class="block text-sm font-medium text-gray-700 mb-1">{{ $t('canned.label') }}:</p>
      <input type="text" name="name" v-model="label" class="focus:ring-indigo-500 focus:border-indigo-500 block border border-gray-300 p-2 w-full rounded-md shadow-sm sm:text-sm ">
      <div v-for="error of v$.label.$errors" :key="error.$uid">
        <div class="text-red-600 text-sm mt-1 mb-2">{{ error.$message }}</div>
      </div>
    </div>
    <div class="mt-4">
      <p class="block text-sm font-medium text-gray-700 mb-1">{{ $t('automations.active') }}:</p>
      <ActiveWidget :active="active" v-on:active-changed="toggleActive" />
      <div v-for="error of v$.active.$errors" :key="error.$uid">
        <div class="text-red-600 text-sm mt-1 mb-2">{{ error.$message }}</div>
      </div>
    </div>
    <div class="mt-4">
      <p class="block text-sm font-medium text-gray-700 mb-1">{{ $t('automations.text') }}:</p>
      <textarea v-model="text" class="focus:ring-indigo-500 focus:border-indigo-500 block border border-gray-300 p-2 w-full rounded-md shadow-sm sm:text-sm "></textarea>
      <div v-for="error of v$.text.$errors" :key="error.$uid">
        <div class="text-red-600 text-sm mt-1 mb-2">{{ error.$message }}</div>
      </div>
    </div>
    <div class="mt-4">
      <p class="text-sm font-medium text-gray-700">{{ $t('canned.attachment') }} ({{ $t('canned.optional') }}):</p>
      <input type="file" name="attachment" @change="saveAttachment" accept=".mp4,.xls,.xlsx,.pdf,.doc,.docx,.odt,.odf,.ods,.odp,.txt,.png,.jpg,.gif" class="focus:ring-indigo-500 focus:border-indigo-500 block border border-gray-300 p-2 w-full rounded-md shadow-sm sm:text-sm ">
      <div v-for="error of v$.text.$errors" :key="error.$uid">
        <div class="text-red-600 text-sm mt-1 mb-2">{{ error.$message }}</div>
      </div>
    </div>
  </modalForm>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import modalForm from '../../building_blocks/modalForm'
import formViewMixin from '../../building_blocks/formViewMixin'
import cannedMessageModel from '@/models/cannedMessage'
import ActiveWidget from '../automations/ActiveWidget'


export default {
  mixins: [formViewMixin],
  props: ['message'],
  name: 'CannedEdit',
  setup () {
    return { v$: useVuelidate() }
  },
  components: {
    modalForm,
    ActiveWidget,
  },
  created() {
    this.label = this.message.attributes.label;
    this.active = this.message.attributes.active;
    this.text = this.message.attributes.text;
  },
  methods: {
    async onFormValid() {
      let response;
      let cannedData = cannedMessageModel.buildUpdate(this.message.id, this.label, this.active, this.text, this.attachment);
      try {
        response = await cannedMessageModel.updateMessage(this.message.id, cannedData, this.axios, this.$root.token);
      } catch(error) {
        this.error = this.$t('canned.errorUpdating');
      }
      if (response && response.status === 204) {
          this.error = '';
          this.$emit('update-finished-event');
      }
    },
    cancel() {
      this.$emit('update-finished-event');
    },
    toggleActive() {
      this.active = !this.active;
    },
    saveAttachment(event) {
      let file = event.target.files[0];
      let maxSize = process.env.VUE_APP_MAX_ATTACHMENT_SIZE_IN_MB * 1024 * 1024;
      if(file.size <= maxSize) {
        let reader = new FileReader();
        reader.addEventListener('load', (event) => {
          const result = event.target.result;
          this.attachment = {'file': result, 'name':file.name, 'type': file.type};
        });
        reader.readAsDataURL(file);
      }
    }
  },
  data() {
    return {
      'label': '',
      'active': '',
      'text': '',
      'error': '',
      'attachment': undefined,
    }
  },
  validations () {
    return {
      'label': { required },
      'active': { },
      'text': { required },
    }
  }
}
</script>
